module.exports = __webpack_public_path__ + "static/img/股权激励_文件包.1d8cf35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/股权激励_文件包.jpg
// module id = Sx+C
// module chunks = 1